let discount = 40;

let bedOption = {
  bedFrameShape: {
    hb: "Plain Jane",
    fb: "Plain Jane",
  },
  upholestery: {
    hb: "Plain Jane",
    fb: "Plain Jane",
  },
  additionFeature: {
    wings: "None",
    wing_beading: "",
    bumper: "None",
    bumper_beading: "",
  },
  material: "Plush-Steel Grey",
  pholesteryFinish: "Matching Fabric Buttons",
  headboardHeight: 'Standard Height 48"',
  footboardHeight: 'Petite Footboard 12"',
  legs: "No Legs",
  frameSupport: "Solid Flat Wooden Slats",
  underBedLowerFloor: "Not Required",
  mattress: "Not Required",
  ottomanBox: "Not Required",
  SSAssembly: "Service Not Required",
  disposal: "Removal Not Required",
  delivery: "Deliver As Soon As Possible",
  matressPockets: "1000 Pockets",
};
let prevsel = JSON.parse(localStorage.getItem("userSel"))?.bedOption;
let count = 0;
if (prevsel && count == 0) {
  bedOption = prevsel;
  count = 1;
}

const bedData = {
  bedFrameShape: {
    hb: [
      {
        text: "Plain Jane",
        url: "https://cdn.shopify.com/s/files/1/0518/2157/6345/t/35/assets/HB_Plain%20Jane.png?v=1719169755",
        threeft: 0.0,
        fourft: 0.0,
        fourftSix: 0.0,
        fiveft: 0.0,
        sixft: 0.0,
        inStock: true,
      },
      {
        text: "Rose",
        url: "https://cdn.shopify.com/s/files/1/0518/2157/6345/t/35/assets/HB_Rose.png?v=1719169537",
        threeft: 49.99,
        fourft: 69.99,
        fourftSix: 79.99,
        fiveft: 99.99,
        sixft: 149.99,
        inStock: true,
      },
      {
        text: "Kensington",
        url: "https://cdn.shopify.com/s/files/1/0518/2157/6345/t/35/assets/HB_Kensington.png?v=1719169571",
        threeft: 49.99,
        fourft: 69.99,
        fourftSix: 79.99,
        fiveft: 99.99,
        sixft: 149.99,
        inStock: true,
      },
      {
        text: "Knightbridge",
        url: "https://cdn.shopify.com/s/files/1/0518/2157/6345/t/35/assets/HB_Kensington.png?v=1719169571",
        threeft: 49.99,
        fourft: 69.99,
        fourftSix: 79.99,
        fiveft: 99.99,
        sixft: 149.99,
        inStock: true,
      },
      {
        text: "Hampton",
        url: "https://cdn.shopify.com/s/files/1/0518/2157/6345/t/35/assets/HB_Eva.png?v=1719169655",
        threeft: 49.99,
        fourft: 69.99,
        fourftSix: 79.99,
        fiveft: 99.99,
        sixft: 149.99,
        inStock: true,
      },
      {
        text: "Eva",
        url: "https://cdn.shopify.com/s/files/1/0518/2157/6345/t/35/assets/HB_Hampton.png?v=1719169679",
        threeft: 49.99,
        fourft: 69.99,
        fourftSix: 79.99,
        fiveft: 99.99,
        sixft: 149.99,
        inStock: true,
      },
      {
        text: "Arabella",
        url: "https://cdn.shopify.com/s/files/1/0518/2157/6345/t/35/assets/HB_Arabella.png?v=1719169705",
        threeft: 49.99,
        fourft: 69.99,
        fourftSix: 79.99,
        fiveft: 99.99,
        sixft: 149.99,
        inStock: true,
      },
    ],
    fb: [
      {
        text: "Plain Jane",
        url: "https://cdn.shopify.com/s/files/1/0518/2157/6345/t/42/assets/Plain_Jane.png",
        threeft: 0.0,
        fourft: 0.0,
        fourftSix: 0.0,
        fiveft: 0.0,
        sixft: 0.0,
        inStock: true,
      },
      {
        text: "Rose",
        url: "https://cdn.shopify.com/s/files/1/0518/2157/6345/t/42/assets/Rose.png",
        threeft: 19.99,
        fourft: 39.99,
        fourftSix: 49.99,
        fiveft: 59.99,
        sixft: 79.99,
        inStock: true,
      },
      {
        text: "Kensington",
        url: "https://cdn.shopify.com/s/files/1/0518/2157/6345/t/42/assets/Kensington.png",
        threeft: 19.99,
        fourft: 39.99,
        fourftSix: 49.99,
        fiveft: 59.99,
        sixft: 79.99,
        inStock: true,
      },
      {
        text: "Knightbridge",
        url: "https://cdn.shopify.com/s/files/1/0518/2157/6345/t/42/assets/Knightsbridge.png",
        threeft: 19.99,
        fourft: 39.99,
        fourftSix: 49.99,
        fiveft: 59.99,
        sixft: 79.99,
        inStock: true,
      },
      {
        text: "Hampton",
        url: "https://cdn.shopify.com/s/files/1/0518/2157/6345/t/42/assets/Eva.png",
        threeft: 19.99,
        fourft: 39.99,
        fourftSix: 49.99,
        fiveft: 59.99,
        sixft: 79.99,
        inStock: true,
      },
      {
        text: "Eva",
        url: "https://cdn.shopify.com/s/files/1/0518/2157/6345/t/42/assets/Hampton.png",
        threeft: 19.99,
        fourft: 39.99,
        fourftSix: 49.99,
        fiveft: 59.99,
        sixft: 79.99,
        inStock: true,
      },
      {
        text: "Arabella",
        url: "https://cdn.shopify.com/s/files/1/0518/2157/6345/t/42/assets/Arabella.png",
        threeft: 19.99,
        fourft: 39.99,
        fourftSix: 49.99,
        fiveft: 59.99,
        sixft: 79.99,
        inStock: true,
      },
    ],
  },
  upholestery: {
    hb: [
      {
        text: "Plain Jane",
        url: "https://cdn.shopify.com/s/files/1/0518/2157/6345/t/42/assets/Plain-Jane.png",
        threeft: 0.0,
        fourft: 0.0,
        fourftSix: 0.0,
        fiveft: 0.0,
        sixft: 0.0,
        inStock: true,
      },
      {
        text: "Lines-horizontal-large",
        url: "https://cdn.shopify.com/s/files/1/0518/2157/6345/t/31/assets/Lines-horizontal-large.png",
        threeft: 4.99,
        fourft: 9.99,
        fourftSix: 9.99,
        fiveft: 14.99,
        sixft: 19.99,
        inStock: true,
      },
      {
        text: "Lines-Horizontal-small",
        url: "https://cdn.shopify.com/s/files/1/0518/2157/6345/t/42/assets/Lines-Horizontal-small.png",
        threeft: 9.99,
        fourft: 14.99,
        fourftSix: 14.99,
        fiveft: 19.99,
        sixft: 24.99,
        inStock: true,
      },
      {
        text: "Lines-Vertical-large",
        url: "https://cdn.shopify.com/s/files/1/0518/2157/6345/t/42/assets/Lines-Vertical-large.png",
        threeft: 4.99,
        fourft: 9.99,
        fourftSix: 9.99,
        fiveft: 14.99,
        sixft: 19.99,
        inStock: true,
      },
      {
        text: "Lines-Vertical-Small",
        url: "https://cdn.shopify.com/s/files/1/0518/2157/6345/t/42/assets/Lines-Vertical-Small.png",
        threeft: 9.99,
        fourft: 14.99,
        fourftSix: 14.99,
        fiveft: 19.99,
        sixft: 24.99,
        inStock: true,
      },
      {
        text: "Cube-Design-Large",
        url: "https://cdn.shopify.com/s/files/1/0518/2157/6345/t/42/assets/Cube-Design-Large.png",
        threeft: 4.99,
        fourft: 9.99,
        fourftSix: 9.99,
        fiveft: 14.99,
        sixft: 19.99,
        inStock: true,
      },
      {
        text: "Cube-Design-small",
        url: "https://cdn.shopify.com/s/files/1/0518/2157/6345/t/42/assets/Cube-Design-small.png",
        threeft: 9.99,
        fourft: 14.99,
        fourftSix: 14.99,
        fiveft: 19.99,
        sixft: 24.99,
        inStock: true,
      },
      {
        text: "Sunrise",
        url: "https://cdn.shopify.com/s/files/1/0518/2157/6345/t/42/assets/Sunrise.png",
        threeft: 4.99,
        fourft: 9.99,
        fourftSix: 9.99,
        fiveft: 14.99,
        sixft: 19.99,
        inStock: true,
      },
      {
        text: "Victoria",
        url: "https://cdn.shopify.com/s/files/1/0518/2157/6345/t/42/assets/Victoria.png",
        threeft: 4.99,
        fourft: 9.99,
        fourftSix: 9.99,
        fiveft: 14.99,
        sixft: 19.99,
        inStock: true,
      },
      {
        text: "ChesterField-Large",
        url: "https://cdn.shopify.com/s/files/1/0518/2157/6345/t/42/assets/ChesterField-Large.png",
        threeft: 19.99,
        fourft: 24.99,
        fourftSix: 24.99,
        fiveft: 29.99,
        sixft: 34.99,
        inStock: true,
      },
      {
        text: "Chesterfield-Small",
        url: "https://cdn.shopify.com/s/files/1/0518/2157/6345/t/42/assets/Chesterfield-Small.png",
        threeft: 39.99,
        fourft: 44.99,
        fourftSix: 44.99,
        fiveft: 49.99,
        sixft: 54.99,
        inStock: true,
      },
      {
        text: "Majestic-Multi-Panel",
        url: "https://cdn.shopify.com/s/files/1/0518/2157/6345/t/42/assets/Majestic-Multi-Panel.png",
        threeft: 149.99,
        fourft: 199.99,
        fourftSix: 199.99,
        fiveft: 224.99,
        sixft: 299.99,
        inStock: true,
      },
    ],
    fb: [
      {
        text: "Plain Jane",
        url: "https://cdn.shopify.com/s/files/1/0518/2157/6345/t/42/assets/Plain_Jane.png",
        threeft: 0.0,
        fourft: 0.0,
        fourftSix: 0.0,
        fiveft: 0.0,
        sixft: 0.0,
        inStock: true,
      },
      {
        text: "Lines-horizontal-large",
        url: "https://cdn.shopify.com/s/files/1/0518/2157/6345/t/42/assets/FB_Lines_horizontal_large.png",
        threeft: 4.99,
        fourft: 9.99,
        fourftSix: 9.99,
        fiveft: 14.99,
        sixft: 19.99,
        inStock: true,
      },
      {
        text: "Lines-Horizontal-small",
        url: "https://cdn.shopify.com/s/files/1/0518/2157/6345/t/42/assets/FB_Lines_Horizontal_small.png",
        threeft: 9.99,
        fourft: 14.99,
        fourftSix: 14.99,
        fiveft: 19.99,
        sixft: 24.99,
        inStock: true,
      },
      {
        text: "Lines-Vertical-large",
        url: "https://cdn.shopify.com/s/files/1/0518/2157/6345/t/42/assets/FB_Lines_Vertical_large.png",
        threeft: 4.99,
        fourft: 9.99,
        fourftSix: 9.99,
        fiveft: 14.99,
        sixft: 19.99,
        inStock: true,
      },
      {
        text: "Lines-Vertical-Small",
        url: "https://cdn.shopify.com/s/files/1/0518/2157/6345/t/42/assets/FB_Lines_Vertical_Small.png",
        threeft: 9.99,
        fourft: 14.99,
        fourftSix: 14.99,
        fiveft: 19.99,
        sixft: 24.99,
        inStock: true,
      },
      {
        text: "Cube-Design-Large",
        url: "https://cdn.shopify.com/s/files/1/0518/2157/6345/t/42/assets/FB_Cube_Design_Large.png",
        threeft: 4.99,
        fourft: 9.99,
        fourftSix: 9.99,
        fiveft: 14.99,
        sixft: 19.99,
        inStock: true,
      },
      {
        text: "Cube-Design-small",
        url: "https://cdn.shopify.com/s/files/1/0518/2157/6345/t/42/assets/FB_Cube_Design_small.png",
        threeft: 9.99,
        fourft: 14.99,
        fourftSix: 14.99,
        fiveft: 19.99,
        sixft: 24.99,
        inStock: true,
      },
      {
        text: "Sunrise",
        url: "https://cdn.shopify.com/s/files/1/0518/2157/6345/t/42/assets/FB_Sunrise.png",
        threeft: 4.99,
        fourft: 9.99,
        fourftSix: 9.99,
        fiveft: 14.99,
        sixft: 19.99,
        inStock: true,
      },
      {
        text: "Victoria",
        url: "https://cdn.shopify.com/s/files/1/0518/2157/6345/t/42/assets/FB_Victoria.png",
        threeft: 4.99,
        fourft: 9.99,
        fourftSix: 9.99,
        fiveft: 14.99,
        sixft: 19.99,
        inStock: true,
      },
      {
        text: "ChesterField-Large",
        url: "https://cdn.shopify.com/s/files/1/0518/2157/6345/t/42/assets/FB_FB_ChesterField_Large.png",
        threeft: 19.99,
        fourft: 24.99,
        fourftSix: 24.99,
        fiveft: 29.99,
        sixft: 34.99,
        inStock: true,
      },
      {
        text: "Chesterfield-Small",
        url: "https://cdn.shopify.com/s/files/1/0518/2157/6345/t/42/assets/FB_Chesterfield_Small.png",
        threeft: 39.99,
        fourft: 44.99,
        fourftSix: 44.99,
        fiveft: 49.99,
        sixft: 54.99,
        inStock: true,
      },
      {
        text: "Majestic-Multi-Panel",
        url: "https://cdn.shopify.com/s/files/1/0518/2157/6345/t/42/assets/FB_Majestic_Multi_Panel.png",
        threeft: 149.99,
        fourft: 199.99,
        fourftSix: 199.99,
        fiveft: 224.99,
        sixft: 299.99,
        inStock: true,
      },
    ],
  },
  additionFeature: {
    wings: [
      {
        text: "None",
        url: "https://cdn.shopify.com/s/files/1/0518/2157/6345/t/42/assets/traffic-signal.png",
        threeft: 0.0,
        fourft: 0.0,
        fourftSix: 0.0,
        fiveft: 0.0,
        sixft: 0.0,
        inStock: true,
      },
      {
        text: "StraightWing–Plain",
        url: "https://cdn.shopify.com/s/files/1/0518/2157/6345/t/35/assets/Straight_Wing.png?v=1719169851",
        threeft: 39.99,
        fourft: 39.99,
        fourftSix: 39.99,
        fiveft: 39.99,
        sixft: 39.99,
        inStock: true,
      },
      {
        text: "CurvedWing–Plain",
        url: "https://cdn.shopify.com/s/files/1/0518/2157/6345/t/35/assets/Curved_Wings.png?v=1719169880",
        threeft: 59.99,
        fourft: 59.99,
        fourftSix: 59.99,
        fiveft: 59.99,
        sixft: 59.99,
        inStock: true,
      },
    ],
    bumper: [
      {
        text: "None",
        url: "https://cdn.shopify.com/s/files/1/0518/2157/6345/t/42/assets/traffic-signal.png",
        threeft: 0.0,
        fourft: 0.0,
        fourftSix: 0.0,
        fiveft: 0.0,
        sixft: 0.0,
        inStock: true,
      },
      {
        text: "Bumper Border–Plain",
        url: "https://cdn.shopify.com/s/files/1/0518/2157/6345/t/26/assets/Bumper_border.png",
        threeft: 49.99,
        fourft: 49.99,
        fourftSix: 49.99,
        fiveft: 49.99,
        sixft: 49.99,
        inStock: true,
      },
    ],
  },
  material: {
    Chenille: [
      {
        text: "Silver",
        url: "https://cdn.shopify.com/s/files/1/0518/2157/6345/t/42/assets/Chenille-Silver.png",
        threeft: 59.99,
        fourft: 69.99,
        fourftSix: 79.99,
        fiveft: 89.99,
        sixft: 99.99,
        inStock: true,
      },
      {
        text: "Charcoal Grey",
        url: "https://cdn.shopify.com/s/files/1/0518/2157/6345/t/42/assets/Chenille-CharcoalGrey.png",
        threeft: 59.99,
        fourft: 69.99,
        fourftSix: 79.99,
        fiveft: 89.99,
        sixft: 99.99,
        inStock: true,
      },
      {
        text: "Black",
        url: "https://cdn.shopify.com/s/files/1/0518/2157/6345/t/42/assets/Chenille-Black.png",
        threeft: 59.99,
        fourft: 69.99,
        fourftSix: 79.99,
        fiveft: 89.99,
        sixft: 99.99,
        inStock: true,
      },
      // {
      //   text: "Cream",
      //   url: "https://cdn.shopify.com/s/files/1/0518/2157/6345/t/42/assets/Chenille-Cream.png",
      //   threeft: 59.99,
      //   fourft: 69.99,
      //   fourftSix: 79.99,
      //   fiveft: 89.99,
      //   sixft: 99.99,
      //   inStock: true,
      // },
      {
        text: "Mink",
        url: "https://cdn.shopify.com/s/files/1/0518/2157/6345/t/42/assets/Chenille-Mink.png",
        threeft: 59.99,
        fourft: 69.99,
        fourftSix: 79.99,
        fiveft: 89.99,
        sixft: 99.99,
        inStock: true,
      },
      {
        text: "Teal",
        url: "https://cdn.shopify.com/s/files/1/0518/2157/6345/t/42/assets/Chenille-Teal.png",
        threeft: 59.99,
        fourft: 69.99,
        fourftSix: 79.99,
        fiveft: 89.99,
        sixft: 99.99,
        inStock: true,
      },
      {
        text: "Red",
        url: "https://cdn.shopify.com/s/files/1/0518/2157/6345/t/42/assets/Chenille-Red.png",
        threeft: 59.99,
        fourft: 69.99,
        fourftSix: 79.99,
        fiveft: 89.99,
        sixft: 99.99,
        inStock: true,
      },
      {
        text: "Purple",
        url: "https://cdn.shopify.com/s/files/1/0518/2157/6345/t/42/assets/Chenille-Purple.png",
        threeft: 59.99,
        fourft: 69.99,
        fourftSix: 79.99,
        fiveft: 89.99,
        sixft: 99.99,
        inStock: true,
      },
    ],
    Coniston: [
      {
        text: "Silver",
        url: "https://cdn.shopify.com/s/files/1/0518/2157/6345/t/42/assets/Coniston-Silver.png",
        threeft: 49.99,
        fourft: 59.99,
        fourftSix: 69.99,
        fiveft: 79.99,
        sixft: 89.99,
        inStock: true,
      },
      {
        text: "Grey",
        url: "https://cdn.shopify.com/s/files/1/0518/2157/6345/t/42/assets/Coniston-Grey.png",
        threeft: 49.99,
        fourft: 59.99,
        fourftSix: 69.99,
        fiveft: 79.99,
        sixft: 89.99,
        inStock: true,
      },
      {
        text: "Cream",
        url: "https://cdn.shopify.com/s/files/1/0518/2157/6345/t/42/assets/Coniston-Cream.png",
        threeft: 49.99,
        fourft: 59.99,
        fourftSix: 69.99,
        fiveft: 79.99,
        sixft: 89.99,
        inStock: true,
      },
      {
        text: "Mink",
        url: "https://cdn.shopify.com/s/files/1/0518/2157/6345/t/42/assets/Coniston-Mink.png",
        threeft: 49.99,
        fourft: 59.99,
        fourftSix: 69.99,
        fiveft: 79.99,
        sixft: 89.99,
        inStock: true,
      },
      {
        text: "Turmeric",
        url: "https://cdn.shopify.com/s/files/1/0518/2157/6345/t/42/assets/Coniston-Turmeric.png",
        threeft: 49.99,
        fourft: 59.99,
        fourftSix: 69.99,
        fiveft: 79.99,
        sixft: 89.99,
        inStock: true,
      },
      {
        text: "Claret",
        url: "https://cdn.shopify.com/s/files/1/0518/2157/6345/t/42/assets/Coniston-claret.png",
        threeft: 49.99,
        fourft: 59.99,
        fourftSix: 69.99,
        fiveft: 79.99,
        sixft: 89.99,
        inStock: true,
      },
      {
        text: "Pink",
        url: "https://cdn.shopify.com/s/files/1/0518/2157/6345/t/42/assets/Coniston-Pink.png",
        threeft: 49.99,
        fourft: 59.99,
        fourftSix: 69.99,
        fiveft: 79.99,
        sixft: 89.99,
        inStock: true,
      },
      {
        text: "Blue",
        url: "https://cdn.shopify.com/s/files/1/0518/2157/6345/t/42/assets/Coniston-Blue.png",
        threeft: 49.99,
        fourft: 59.99,
        fourftSix: 69.99,
        fiveft: 79.99,
        sixft: 89.99,
        inStock: true,
      },
      {
        text: "Emerald",
        url: "https://cdn.shopify.com/s/files/1/0518/2157/6345/t/42/assets/Coniston-Emerald.png",
        threeft: 49.99,
        fourft: 59.99,
        fourftSix: 69.99,
        fiveft: 79.99,
        sixft: 89.99,
        inStock: true,
      },
    ],
    Crushed: [
      {
        text: "Ice Silver",
        url: "https://cdn.shopify.com/s/files/1/0518/2157/6345/t/42/assets/CrushedVelvet-IceSilver.png",
        threeft: 0.0,
        fourft: 0.0,
        fourftSix: 0.0,
        fiveft: 0.0,
        sixft: 0.0,
        inStock: true,
      },
      {
        text: "Charcoal Grey",
        url: "https://cdn.shopify.com/s/files/1/0518/2157/6345/t/42/assets/CrushedVelvet-CharcoalGrey.png",
        threeft: 0.0,
        fourft: 0.0,
        fourftSix: 0.0,
        fiveft: 0.0,
        sixft: 0.0,
        inStock: true,
      },
      {
        text: "Black Noir",
        url: "https://cdn.shopify.com/s/files/1/0518/2157/6345/t/42/assets/CrushedVelvet-NoirBlack.png",
        threeft: 0.0,
        fourft: 0.0,
        fourftSix: 0.0,
        fiveft: 0.0,
        sixft: 0.0,
        inStock: true,
      },
      {
        text: "Blanc white",
        url: "https://cdn.shopify.com/s/files/1/0518/2157/6345/t/42/assets/CrushedVelvet-BlancWhite.png",
        threeft: 0.0,
        fourft: 0.0,
        fourftSix: 0.0,
        fiveft: 0.0,
        sixft: 0.0,
        inStock: true,
      },
      {
        text: "Champange Cream",
        url: "https://cdn.shopify.com/s/files/1/0518/2157/6345/t/42/assets/CrushedVelvet-ChampagneCream.png",
        threeft: 0.0,
        fourft: 0.0,
        fourftSix: 0.0,
        fiveft: 0.0,
        sixft: 0.0,
        inStock: true,
      },
      {
        text: "Gold",
        url: "https://cdn.shopify.com/s/files/1/0518/2157/6345/t/42/assets/CrushedVelvet-Gold.png",
        threeft: 0.0,
        fourft: 0.0,
        fourftSix: 0.0,
        fiveft: 0.0,
        sixft: 0.0,
        inStock: true,
      },
      {
        text: "Truffle Mink",
        url: "https://cdn.shopify.com/s/files/1/0518/2157/6345/t/42/assets/CrushedVelvet-MinkTruffle.png",
        threeft: 0.0,
        fourft: 0.0,
        fourftSix: 0.0,
        fiveft: 0.0,
        sixft: 0.0,
        inStock: true,
      },
      {
        text: "Baby Pink",
        url: "https://cdn.shopify.com/s/files/1/0518/2157/6345/t/42/assets/CrushedVelvet-BabyPink.png",
        threeft: 0.0,
        fourft: 0.0,
        fourftSix: 0.0,
        fiveft: 0.0,
        sixft: 0.0,
        inStock: true,
      },
      {
        text: "Denim Blue",
        url: "https://cdn.shopify.com/s/files/1/0518/2157/6345/t/42/assets/CrushedVelvet-DenimBlue.png",
        threeft: 0.0,
        fourft: 0.0,
        fourftSix: 0.0,
        fiveft: 0.0,
        sixft: 0.0,
        inStock: true,
      },
      {
        text: "Abuergine Purple",
        url: "https://cdn.shopify.com/s/files/1/0518/2157/6345/t/42/assets/CrushedVelvet-AuberginePurple.png",
        threeft: 0.0,
        fourft: 0.0,
        fourftSix: 0.0,
        fiveft: 0.0,
        sixft: 0.0,
        inStock: true,
      },
      {
        text: "Rose Red",
        url: "https://cdn.shopify.com/s/files/1/0518/2157/6345/t/42/assets/CrushedVelvet-RoseRed.png",
        threeft: 0.0,
        fourft: 0.0,
        fourftSix: 0.0,
        fiveft: 0.0,
        sixft: 0.0,
        inStock: true,
      },
    ],
    Greek: [
      {
        text: "Silver",
        url: "https://cdn.shopify.com/s/files/1/0518/2157/6345/t/42/assets/GreekMystic-Silver.png",
        threeft: 109.99,
        fourft: 119.99,
        fourftSix: 129.99,
        fiveft: 149.99,
        sixft: 169.99,
        inStock: true,
      },
      {
        text: "Grey",
        url: "https://cdn.shopify.com/s/files/1/0518/2157/6345/t/42/assets/GreekMystik-Grey.png",
        threeft: 109.99,
        fourft: 119.99,
        fourftSix: 129.99,
        fiveft: 149.99,
        sixft: 169.99,
        inStock: true,
      },
      {
        text: "Ivory Cream",
        url: "https://cdn.shopify.com/s/files/1/0518/2157/6345/t/42/assets/GreekMystic-IvoryCream.png",
        threeft: 109.99,
        fourft: 119.99,
        fourftSix: 129.99,
        fiveft: 149.99,
        sixft: 169.99,
        inStock: true,
      },
      {
        text: "Truffle Mink",
        url: "https://cdn.shopify.com/s/files/1/0518/2157/6345/t/42/assets/GreekMystic-TruffleMink.png",
        threeft: 109.99,
        fourft: 119.99,
        fourftSix: 129.99,
        fiveft: 149.99,
        sixft: 169.99,
        inStock: true,
      },
      {
        text: "Red",
        url: "https://cdn.shopify.com/s/files/1/0518/2157/6345/t/42/assets/GreekMystic-Red.png",
        threeft: 109.99,
        fourft: 119.99,
        fourftSix: 129.99,
        fiveft: 149.99,
        sixft: 169.99,
        inStock: true,
      },
      {
        text: "Baby Pink",
        url: "https://cdn.shopify.com/s/files/1/0518/2157/6345/t/42/assets/GreekMystic-Pink.png",
        threeft: 109.99,
        fourft: 119.99,
        fourftSix: 129.99,
        fiveft: 149.99,
        sixft: 169.99,
        inStock: true,
      },
      {
        text: "Ice Blue",
        url: "https://cdn.shopify.com/s/files/1/0518/2157/6345/t/42/assets/Greek_Mystic_Ice_Blue.png",
        threeft: 109.99,
        fourft: 119.99,
        fourftSix: 129.99,
        fiveft: 149.99,
        sixft: 169.99,
        inStock: true,
      },
      {
        text: "Parliament Blue",
        url: "https://cdn.shopify.com/s/files/1/0518/2157/6345/t/42/assets/GreekMystic-ParliamentBlue.png",
        threeft: 109.99,
        fourft: 119.99,
        fourftSix: 129.99,
        fiveft: 149.99,
        sixft: 169.99,
        inStock: true,
      },
      {
        text: "Emerald Green",
        url: "https://cdn.shopify.com/s/files/1/0518/2157/6345/t/42/assets/GreekMystic-EmeraldGreen.png",
        threeft: 109.99,
        fourft: 119.99,
        fourftSix: 129.99,
        fiveft: 149.99,
        sixft: 169.99,
        inStock: true,
      },
      {
        text: "Gold",
        url: "https://cdn.shopify.com/s/files/1/0518/2157/6345/t/42/assets/GreekMystic-Gold.png",
        threeft: 109.99,
        fourft: 119.99,
        fourftSix: 129.99,
        fiveft: 149.99,
        sixft: 169.99,
        inStock: true,
      },
      {
        text: "Plum Purple",
        url: "https://cdn.shopify.com/s/files/1/0518/2157/6345/t/42/assets/GreekMystic-PlumPurple.png",
        threeft: 109.99,
        fourft: 119.99,
        fourftSix: 129.99,
        fiveft: 149.99,
        sixft: 169.99,
        inStock: true,
      },
    ],
    Linen: [
      {
        text: "Silver",
        url: "https://cdn.shopify.com/s/files/1/0518/2157/6345/t/42/assets/Linen-Silver.png",
        threeft: 59.99,
        fourft: 69.99,
        fourftSix: 79.99,
        fiveft: 89.99,
        sixft: 99.99,
        inStock: true,
      },
      {
        text: "Grey",
        url: "https://cdn.shopify.com/s/files/1/0518/2157/6345/t/42/assets/Linen-Grey.png",
        threeft: 59.99,
        fourft: 69.99,
        fourftSix: 79.99,
        fiveft: 89.99,
        sixft: 99.99,
        inStock: true,
      },
      {
        text: "Black",
        url: "https://cdn.shopify.com/s/files/1/0518/2157/6345/t/42/assets/Linen-Black.png",
        threeft: 59.99,
        fourft: 69.99,
        fourftSix: 79.99,
        fiveft: 89.99,
        sixft: 99.99,
        inStock: true,
      },
      {
        text: "Stone Cream",
        url: "https://cdn.shopify.com/s/files/1/0518/2157/6345/t/42/assets/Linen-StoneCream.png",
        threeft: 59.99,
        fourft: 69.99,
        fourftSix: 79.99,
        fiveft: 89.99,
        sixft: 99.99,
        inStock: true,
      },
      {
        text: "Mink",
        url: "https://cdn.shopify.com/s/files/1/0518/2157/6345/t/42/assets/Linen-Mink.png",
        threeft: 59.99,
        fourft: 69.99,
        fourftSix: 79.99,
        fiveft: 89.99,
        sixft: 99.99,
        inStock: true,
      },
      {
        text: "Pink",
        url: "https://cdn.shopify.com/s/files/1/0518/2157/6345/t/42/assets/Linen-Pink.png",
        threeft: 59.99,
        fourft: 69.99,
        fourftSix: 79.99,
        fiveft: 89.99,
        sixft: 99.99,
        inStock: true,
      },
      {
        text: "Denim",
        url: "https://cdn.shopify.com/s/files/1/0518/2157/6345/t/42/assets/Linen-Denim.png",
        threeft: 59.99,
        fourft: 69.99,
        fourftSix: 79.99,
        fiveft: 89.99,
        sixft: 99.99,
        inStock: true,
      },
      {
        text: "Duckegg",
        url: "https://cdn.shopify.com/s/files/1/0518/2157/6345/t/42/assets/Linen-Duckegg.png",
        threeft: 59.99,
        fourft: 69.99,
        fourftSix: 79.99,
        fiveft: 89.99,
        sixft: 99.99,
        inStock: true,
      },
    ],
    Naples: [
      {
        text: "Silver",
        url: "https://cdn.shopify.com/s/files/1/0518/2157/6345/t/42/assets/Naples-Silver.png",
        threeft: 49.99,
        fourft: 59.99,
        fourftSix: 69.99,
        fiveft: 79.99,
        sixft: 89.99,
        inStock: true,
      },
      {
        text: "grey",
        url: "https://cdn.shopify.com/s/files/1/0518/2157/6345/t/42/assets/Naples-grey.png",
        threeft: 49.99,
        fourft: 59.99,
        fourftSix: 69.99,
        fiveft: 79.99,
        sixft: 89.99,
        inStock: true,
      },
      // {
      //   text: "Black",
      //   url: "https://cdn.shopify.com/s/files/1/0518/2157/6345/t/42/assets/Naples-Black.png",
      //   threeft: 49.99,
      //   fourft: 59.99,
      //   fourftSix: 69.99,
      //   fiveft: 79.99,
      //   sixft: 89.99,
      //   inStock: true,
      // },
      {
        text: "Cream",
        url: "https://cdn.shopify.com/s/files/1/0518/2157/6345/t/42/assets/Naples-Cream.png",
        threeft: 49.99,
        fourft: 59.99,
        fourftSix: 69.99,
        fiveft: 79.99,
        sixft: 89.99,
        inStock: true,
      },
      {
        text: "Mink",
        url: "https://cdn.shopify.com/s/files/1/0518/2157/6345/t/42/assets/Naples-Mink.png",
        threeft: 49.99,
        fourft: 59.99,
        fourftSix: 69.99,
        fiveft: 79.99,
        sixft: 89.99,
        inStock: true,
      },
      {
        text: "Olive",
        url: "https://cdn.shopify.com/s/files/1/0518/2157/6345/t/42/assets/Naples-Olive.png",
        threeft: 49.99,
        fourft: 59.99,
        fourftSix: 69.99,
        fiveft: 79.99,
        sixft: 89.99,
        inStock: true,
      },
      {
        text: "Blue",
        url: "https://cdn.shopify.com/s/files/1/0518/2157/6345/t/42/assets/Naples-Blue.png",
        threeft: 49.99,
        fourft: 59.99,
        fourftSix: 69.99,
        fiveft: 79.99,
        sixft: 89.99,
        inStock: true,
      },
      {
        text: "Orange",
        url: "https://cdn.shopify.com/s/files/1/0518/2157/6345/t/42/assets/Naples-Orange.png",
        threeft: 49.99,
        fourft: 59.99,
        fourftSix: 69.99,
        fiveft: 79.99,
        sixft: 89.99,
        inStock: true,
      },
      {
        text: "Pink",
        url: "https://cdn.shopify.com/s/files/1/0518/2157/6345/t/42/assets/Naples-Pink.png",
        threeft: 49.99,
        fourft: 59.99,
        fourftSix: 69.99,
        fiveft: 79.99,
        sixft: 89.99,
        inStock: true,
      },
    ],
    Plush: [
      {
        text: "Silver Pebble",
        url: "https://cdn.shopify.com/s/files/1/0518/2157/6345/t/42/assets/Plush-SilverPebble.png",
        threeft: 0.0,
        fourft: 0.0,
        fourftSix: 0.0,
        fiveft: 0.0,
        sixft: 0.0,
        inStock: true,
      },
      {
        text: "Steel Grey",
        url: "https://cdn.shopify.com/s/files/1/0518/2157/6345/t/42/assets/Plush-SteelGrey.png",
        threeft: 0.0,
        fourft: 0.0,
        fourftSix: 0.0,
        fiveft: 0.0,
        sixft: 0.0,
        inStock: true,
      },
      {
        text: "Black Noir",
        url: "https://cdn.shopify.com/s/files/1/0518/2157/6345/t/42/assets/Plush-BlackNoir.png",
        threeft: 0.0,
        fourft: 0.0,
        fourftSix: 0.0,
        fiveft: 0.0,
        sixft: 0.0,
        inStock: true,
      },
      {
        text: "Ivory Cream",
        url: "https://cdn.shopify.com/s/files/1/0518/2157/6345/t/42/assets/Plush-IvoryCream.png",
        threeft: 0.0,
        fourft: 0.0,
        fourftSix: 0.0,
        fiveft: 0.0,
        sixft: 0.0,
        inStock: true,
      },
      {
        text: "Baby Pink",
        url: "https://cdn.shopify.com/s/files/1/0518/2157/6345/t/42/assets/Plush_Baby_Pink.png",
        threeft: 0.0,
        fourft: 0.0,
        fourftSix: 0.0,
        fiveft: 0.0,
        sixft: 0.0,
        inStock: true,
      },
      {
        text: "Burgundy",
        url: "https://cdn.shopify.com/s/files/1/0518/2157/6345/t/42/assets/Plush-Burgundy.png",
        threeft: 0.0,
        fourft: 0.0,
        fourftSix: 0.0,
        fiveft: 0.0,
        sixft: 0.0,
        inStock: true,
      },
      {
        text: "Purple Plum",
        url: "https://cdn.shopify.com/s/files/1/0518/2157/6345/t/42/assets/Plush-PurplePlum.png",
        threeft: 0.0,
        fourft: 0.0,
        fourftSix: 0.0,
        fiveft: 0.0,
        sixft: 0.0,
        inStock: true,
      },
      {
        text: "Turmeric",
        url: "https://cdn.shopify.com/s/files/1/0518/2157/6345/t/42/assets/Plush-Turmeric.png",
        threeft: 0.0,
        fourft: 0.0,
        fourftSix: 0.0,
        fiveft: 0.0,
        sixft: 0.0,
        inStock: true,
      },
      {
        text: "Midnight Blue",
        url: "https://cdn.shopify.com/s/files/1/0518/2157/6345/t/42/assets/Plush-Blue.png",
        threeft: 0.0,
        fourft: 0.0,
        fourftSix: 0.0,
        fiveft: 0.0,
        sixft: 0.0,
        inStock: true,
      },
      {
        text: "Ice Blue",
        url: "https://cdn.shopify.com/s/files/1/0518/2157/6345/t/42/assets/Plush-IceBlue.png",
        threeft: 0.0,
        fourft: 0.0,
        fourftSix: 0.0,
        fiveft: 0.0,
        sixft: 0.0,
        inStock: true,
      },
      {
        text: "Mallard",
        url: "https://cdn.shopify.com/s/files/1/0518/2157/6345/t/42/assets/Plush-Mallard.png",
        threeft: 0.0,
        fourft: 0.0,
        fourftSix: 0.0,
        fiveft: 0.0,
        sixft: 0.0,
        inStock: true,
      },
      {
        text: "Emerald",
        url: "https://cdn.shopify.com/s/files/1/0518/2157/6345/t/42/assets/Plush-Emerald.png",
        threeft: 0.0,
        fourft: 0.0,
        fourftSix: 0.0,
        fiveft: 0.0,
        sixft: 0.0,
        inStock: true,
      },
    ],
    Suede: [
      {
        text: "Slate Grey",
        url: "https://cdn.shopify.com/s/files/1/0518/2157/6345/t/42/assets/Suede-SilverPebble(Right)-SlateGrey(Left).png",
        threeft: 29.99,
        fourft: 49.99,
        fourftSix: 59.99,
        fiveft: 69.99,
        sixft: 79.99,
        inStock: true,
      },
      {
        text: "Black Noir",
        url: "https://cdn.shopify.com/s/files/1/0518/2157/6345/t/42/assets/Suede-BlackNoir.png",
        threeft: 29.99,
        fourft: 49.99,
        fourftSix: 59.99,
        fiveft: 69.99,
        sixft: 79.99,
        inStock: true,
      },
      {
        text: "Brown Cappucino",
        url: "https://cdn.shopify.com/s/files/1/0518/2157/6345/t/42/assets/Suede-BrownCappucino.png",
        threeft: 29.99,
        fourft: 49.99,
        fourftSix: 59.99,
        fiveft: 69.99,
        sixft: 79.99,
        inStock: true,
      },
      {
        text: "Silver Pebble",
        url: "https://cdn.shopify.com/s/files/1/0518/2157/6345/t/42/assets/Suede_Silver_Pebble.png",
        threeft: 0,
        fourft: 0,
        fourftSix: 0,
        fiveft: 0,
        sixft: 0,
        inStock: true,
      },

      {
        text: "Stone Mink",
        url: "https://cdn.shopify.com/s/files/1/0518/2157/6345/t/42/assets/Suede-StoneMink.png",
        threeft: 29.99,
        fourft: 49.99,
        fourftSix: 59.99,
        fiveft: 69.99,
        sixft: 79.99,
        inStock: true,
      },
    ],
    Wool: [
      {
        text: "Silver Chrome",
        url: "https://cdn.shopify.com/s/files/1/0518/2157/6345/t/42/assets/Wool-SilverChrome.png",
        threeft: 109.99,
        fourft: 119.99,
        fourftSix: 129.99,
        fiveft: 149.99,
        sixft: 169.99,
        inStock: true,
      },
      {
        text: "Steel Grey",
        url: "https://cdn.shopify.com/s/files/1/0518/2157/6345/t/42/assets/Wool-SteelGrey.png",
        threeft: 109.99,
        fourft: 119.99,
        fourftSix: 129.99,
        fiveft: 149.99,
        sixft: 169.99,
        inStock: true,
      },
      {
        text: "Wheat Mink",
        url: "https://cdn.shopify.com/s/files/1/0518/2157/6345/t/42/assets/Wool-WheatMink.png",
        threeft: 109.99,
        fourft: 119.99,
        fourftSix: 129.99,
        fiveft: 149.99,
        sixft: 169.99,
        inStock: true,
      },
      {
        text: "Chestnut Brown",
        url: "https://cdn.shopify.com/s/files/1/0518/2157/6345/t/42/assets/Wool-ChestnutBrown.png",
        threeft: 109.99,
        fourft: 119.99,
        fourftSix: 129.99,
        fiveft: 149.99,
        sixft: 169.99,
        inStock: true,
      },
      {
        text: "Jade",
        url: "https://cdn.shopify.com/s/files/1/0518/2157/6345/t/42/assets/Wool-Jade.png",
        threeft: 109.99,
        fourft: 119.99,
        fourftSix: 129.99,
        fiveft: 149.99,
        sixft: 169.99,
        inStock: true,
      },
      {
        text: "Lilac",
        url: "https://cdn.shopify.com/s/files/1/0518/2157/6345/t/42/assets/Wool-Lilac.png",
        threeft: 109.99,
        fourft: 119.99,
        fourftSix: 129.99,
        fiveft: 149.99,
        sixft: 169.99,
        inStock: true,
      },
    ],
    Leather: [
      {
        text: "Grey",
        url: "https://cdn.shopify.com/s/files/1/0518/2157/6345/t/42/assets/Grey_Leather.png",
        threeft: 49.99,
        fourft: 59.99,
        fourftSix: 69.99,
        fiveft: 79.99,
        sixft: 89.99,
        inStock: true,
      },
      {
        text: "Black",
        url: "https://cdn.shopify.com/s/files/1/0518/2157/6345/t/42/assets/Black_Leather.png",
        threeft: 49.99,
        fourft: 59.99,
        fourftSix: 69.99,
        fiveft: 79.99,
        sixft: 89.99,
        inStock: true,
      },
      {
        text: "Brown",
        url: "https://cdn.shopify.com/s/files/1/0518/2157/6345/t/42/assets/Brown_Leather.png",
        threeft: 49.99,
        fourft: 59.99,
        fourftSix: 69.99,
        fiveft: 79.99,
        sixft: 89.99,
        inStock: true,
      },
      {
        text: "White",
        url: "https://cdn.shopify.com/s/files/1/0518/2157/6345/t/26/assets/White_Leather.png",
        threeft: 49.99,
        fourft: 59.99,
        fourftSix: 69.99,
        fiveft: 79.99,
        sixft: 89.99,
        inStock: true,
      },
    ],
  },
  pholesteryFinish: [
    {
      text: "Crystal Diamantes",
      url: "https://cdn.shopify.com/s/files/1/0518/2157/6345/t/42/assets/Crystal-Diamantes.png",
      threeft: 0.0,
      fourft: 0.0,
      fourftSix: 0.0,
      fiveft: 0.0,
      sixft: 0.0,
      inStock: true,
    },
    {
      text: "Matching Fabric Buttons",
      url: "https://cdn.shopify.com/s/files/1/0518/2157/6345/t/42/assets/Matching-Fabric-Buttons.png",
      threeft: 0.0,
      fourft: 0.0,
      fourftSix: 0.0,
      fiveft: 0.0,
      sixft: 0.0,
      inStock: true,
    },
  ],
  headboardHeight: [
    {
      text: 'Standard Height 48"',
      url: "https://cdn.shopify.com/s/files/1/0518/2157/6345/t/42/assets/Standard-Height-50.png",
      threeft: 0.0,
      fourft: 0.0,
      fourftSix: 0.0,
      fiveft: 0.0,
      sixft: 0.0,
      inStock: true,
    },
    {
      text: "54” Headboard",
      url: "https://cdn.shopify.com/s/files/1/0518/2157/6345/t/42/assets/54-Headboard.png",
      threeft: 19.99,
      fourft: 29.99,
      fourftSix: 29.99,
      fiveft: 49.99,
      sixft: 59.99,
      inStock: true,
    },
    {
      text: "Custom Height",
      url: "https://cdn.shopify.com/s/files/1/0518/2157/6345/t/42/assets/Headboard-custom.png",
      threeft: "Enquiry",
      fourft: "Enquiry",
      fourftSix: "Enquiry",
      fiveft: "Enquiry",
      sixft: "Enquiry",
      inStock: true,
    },
  ],
  footboardHeight: [
    {
      text: 'Petite Footboard 12"',
      url: "https://cdn.shopify.com/s/files/1/0518/2157/6345/t/42/assets/Petite-Footboard.png",
      threeft: 0.0,
      fourft: 0.0,
      fourftSix: 0.0,
      fiveft: 0.0,
      sixft: 0.0,
      inStock: true,
    },
    {
      text: 'Moyen Footboard 18"',
      url: "https://cdn.shopify.com/s/files/1/0518/2157/6345/t/42/assets/Moyen-Footboard.png",
      threeft: 49.99,
      fourft: 59.99,
      fourftSix: 69.99,
      fiveft: 79.99,
      sixft: 99.99,
      inStock: true,
    },
    {
      text: 'Haute Footboard 24"',
      url: "https://cdn.shopify.com/s/files/1/0518/2157/6345/t/42/assets/Haute-Footboard.png",
      threeft: 79.99,
      fourft: 89.99,
      fourftSix: 99.99,
      fiveft: 109.99,
      sixft: 129.99,
      inStock: true,
    },
    {
      text: "Custom Height",
      url: "https://cdn.shopify.com/s/files/1/0518/2157/6345/t/42/assets/Footboard-custom-size.png",
      threeft: "Enquiry",
      fourft: "Enquiry",
      fourftSix: "Enquiry",
      fiveft: "Enquiry",
      sixft: "Enquiry",
      inStock: true,
    },
  ],
  legs: {
    metal_legs: [
      {
        text: "Chrome Tube Leg",
        url: "https://cdn.shopify.com/s/files/1/0518/2157/6345/t/35/assets/Chrome_Tube_Stand.png?v=1719170062",
        threeft: 0.0,
        fourft: 0.0,
        fourftSix: 0.0,
        fiveft: 0.0,
        sixft: 0.0,
        inStock: true,
      },
      {
        text: "Chrome L Corner Leg",
        url: "https://cdn.shopify.com/s/files/1/0518/2157/6345/t/35/assets/Chrome_L_Corner_Leg_3ft.png?v=1719170092",
        threeft: 29.99,
        fourft: 29.99,
        fourftSix: 29.99,
        fiveft: 29.99,
        sixft: 29.99,
        inStock: true,
      },
      {
        text: "Chrome Pipe Leg",
        url: "https://cdn.shopify.com/s/files/1/0518/2157/6345/t/35/assets/Chrome_L_corner_Legs.png?v=1719170082",
        threeft: 29.99,
        fourft: 29.99,
        fourftSix: 29.99,
        fiveft: 29.99,
        sixft: 29.99,
        inStock: true,
      },
      {
        text: "Chrome Glides",
        url: "https://cdn.shopify.com/s/files/1/0518/2157/6345/t/35/assets/Chrome_Glides.png?v=1719170108",
        threeft: 29.99,
        fourft: 29.99,
        fourftSix: 29.99,
        fiveft: 29.99,
        sixft: 29.99,
        inStock: true,
      },
    ],
    wooden_legs: [
      {
        text: "Sanded Wooden Bun",
        url: "https://cdn.shopify.com/s/files/1/0518/2157/6345/t/42/assets/Sanded-wooden-bun.png",
        threeft: 49.99,
        fourft: 49.99,
        fourftSix: 49.99,
        fiveft: 49.99,
        sixft: 49.99,
        inStock: true,
      },
      {
        text: "Natural Wooden Bun",
        url: "https://cdn.shopify.com/s/files/1/0518/2157/6345/t/42/assets/Natural-wooden-bun.png",
        threeft: 49.99,
        fourft: 49.99,
        fourftSix: 49.99,
        fiveft: 49.99,
        sixft: 49.99,
        inStock: true,
      },
      {
        text: "Mahogany Wooden Bun",
        url: "https://cdn.shopify.com/s/files/1/0518/2157/6345/t/42/assets/Mahogany-wooden-bun.png",
        threeft: 49.99,
        fourft: 49.99,
        fourftSix: 49.99,
        fiveft: 49.99,
        sixft: 49.99,
        inStock: true,
      },
      {
        text: "Dark Wooden bun",
        url: "https://cdn.shopify.com/s/files/1/0518/2157/6345/t/42/assets/Dark-wooden-bun.png",
        threeft: 49.99,
        fourft: 49.99,
        fourftSix: 49.99,
        fiveft: 49.99,
        sixft: 49.99,
        inStock: true,
      },
    ],
    wooden_legs_nickel: [
      {
        text: "Dark Natural–Silver Cup",
        url: "https://cdn.shopify.com/s/files/1/0518/2157/6345/t/42/assets/Wenge-Natural-Silver-Cup.png",
        threeft: 49.99,
        fourft: 49.99,
        fourftSix: 49.99,
        fiveft: 49.99,
        sixft: 49.99,
        inStock: true,
      },
      {
        text: "Wenge Black–Silver Cup",
        url: "https://cdn.shopify.com/s/files/1/0518/2157/6345/t/42/assets/Dark_Natural_Silver_Cup.png",
        threeft: 49.99,
        fourft: 49.99,
        fourftSix: 49.99,
        fiveft: 49.99,
        sixft: 49.99,
        inStock: true,
      },
    ],
  },
  frameSupport: [
    {
      text: "Solid Flat Wooden Slats",
      url: "https://cdn.shopify.com/s/files/1/0518/2157/6345/t/42/assets/Slate.png",
      threeft: 0.0,
      fourft: 0.0,
      fourftSix: 0.0,
      fiveft: 0.0,
      sixft: 0.0,
      inStock: true,
    },
    {
      text: "Solid Platform Base Board",
      url: "https://cdn.shopify.com/s/files/1/0518/2157/6345/t/42/assets/Solid-baseboard.png",
      threeft: 39.99,
      fourft: 49.99,
      fourftSix: 59.99,
      fiveft: 69.99,
      sixft: 89.99,
      inStock: true,
    },
    {
      text: "Premium Reinforced GasLift Ottoman",
      url: "https://cdn.shopify.com/s/files/1/0518/2157/6345/t/42/assets/Premium-ottoman.png",
      threeft: 109.99,
      fourft: 119.99,
      fourftSix: 129.99,
      fiveft: 149.99,
      sixft: 199.99,
      inStock: true,
    },
  ],
  underBedLowerFloor: [
    {
      text: "Not Required",
      url: "https://cdn.shopify.com/s/files/1/0518/2157/6345/t/42/assets/traffic-signal.png",
      threeft: 0.0,
      fourft: 0.0,
      fourftSix: 0.0,
      fiveft: 0.0,
      sixft: 0.0,
      inStock: true,
    },
    // price is not given
    {
      text: "Lower Board Required",
      url: "https://cdn.shopify.com/s/files/1/0518/2157/6345/t/42/assets/UnderBed_Lower_Floor_Platform.png",
      threeft: 19.99,
      fourft: 19.99,
      fourftSix: 19.99,
      fiveft: 19.99,
      sixft: 19.99,
      inStock: true,
    },
  ],
  // 1000 pock et price missing and new option furnace
  mattress: [
    {
      text: "Not Required",
      url: "https://cdn.shopify.com/s/files/1/0518/2157/6345/t/42/assets/traffic-signal.png",
      threeft: 0.0,
      fourft: 0.0,
      fourftSix: 0.0,
      fiveft: 0.0,
      sixft: 0.0,
      inStock: true,
    },
    {
      text: "Orthopaedic Memory",
      url: "https://cdn.shopify.com/s/files/1/0518/2157/6345/t/35/assets/Orthopaedic_memory.png?v=1719170451",
      threeft: 99.99,
      fourft: 119.99,
      fourftSix: 129.99,
      fiveft: 159.99,
      sixft: 249.99,
      inStock: true,
    },
    {
      text: "Memory Pocket",
      url: "https://cdn.shopify.com/s/files/1/0518/2157/6345/t/35/assets/Memory_Pocket.png?v=1719170459",
      threeft: 149.99,
      fourft: 189.99,
      fourftSix: 199.99,
      fiveft: 239.99,
      sixft: 359.99,
      inStock: true,
    },
    {
      text: "Premium Pocket",
      url: "https://cdn.shopify.com/s/files/1/0518/2157/6345/t/35/assets/Premium_Pocket_Natural.png?v=1719170475",
      threeft: 209.99,
      fourft: 249.99,
      fourftSix: 259.99,
      fiveft: 299.99,
      sixft: 419.99,
      inStock: true,
    },
    {
      text: "Luxury Pocket",
      url: "https://cdn.shopify.com/s/files/1/0518/2157/6345/t/35/assets/Luxury_Pocket%20Pilow_Natural.png?v=1719170467",
      threeft: 279.99,
      fourft: 339.99,
      fourftSix: 349.99,
      fiveft: 399.99,
      sixft: 539.99,
      inStock: true,
    },
  ],
  ottomanBox: [
    {
      text: "Not Required",
      url: "https://cdn.shopify.com/s/files/1/0518/2157/6345/t/42/assets/traffic-signal.png",
      threeft: 0.0,
      fourft: 0.0,
      fourftSix: 0.0,
      fiveft: 0.0,
      sixft: 0.0,
      inStock: true,
    },
    {
      text: "Standard Size",
      url: "https://cdn.shopify.com/s/files/1/0518/2157/6345/t/42/assets/Ottoman_Box.png",
      threeft: 119.99,
      fourft: 119.99,
      fourftSix: 119.99,
      fiveft: 119.99,
      sixft: 119.99,
      inStock: true,
    },
    {
      text: "Same Width As Bed ",
      url: "https://cdn.shopify.com/s/files/1/0518/2157/6345/t/42/assets/Ottoman_Box.png",
      threeft: 119.99,
      fourft: 144.99,
      fourftSix: 149.99,
      fiveft: 169.99,
      sixft: 199.99,
      inStock: true,
    },
  ],
  SSAssembly: [
    {
      text: "Service Not Required",
      url: "https://cdn.shopify.com/s/files/1/0518/2157/6345/t/42/assets/traffic-signal.png",
      threeft: 0.0,
      fourft: 0.0,
      fourftSix: 0.0,
      fiveft: 0.0,
      sixft: 0.0,
      inStock: true,
    },
    {
      text: "Assembly Required",
      url: "https://cdn.shopify.com/s/files/1/0518/2157/6345/t/42/assets/Specialist-Assembly-Service.png",
      threeft: 69.99,
      fourft: 69.99,
      fourftSix: 69.99,
      fiveft: 69.99,
      sixft: 69.99,
      inStock: true,
    },
  ],
  // one option is miissing that is matress removal
  disposal: [
    {
      text: "Removal Not Required",
      url: "https://cdn.shopify.com/s/files/1/0518/2157/6345/t/42/assets/traffic-signal.png",
      threeft: 0.0,
      fourft: 0.0,
      fourftSix: 0.0,
      fiveft: 0.0,
      sixft: 0.0,
      inStock: true,
    },
    {
      text: "Packaging Removal",
      url: "https://cdn.shopify.com/s/files/1/0518/2157/6345/t/26/assets/Packaging-Removal.png",
      threeft: 19.99,
      fourft: 19.99,
      fourftSix: 19.99,
      fiveft: 19.99,
      sixft: 19.99,
      inStock: true,
    },
    {
      text: "Bed Base Removal",
      url: "https://cdn.shopify.com/s/files/1/0518/2157/6345/t/42/assets/Bed-Base-removal.png",
      threeft: 59.99,
      fourft: 59.99,
      fourftSix: 59.99,
      fiveft: 59.99,
      sixft: 59.99,
      inStock: true,
    },
    {
      text: "Mattress Removal",
      url: "https://cdn.shopify.com/s/files/1/0518/2157/6345/t/42/assets/Mattress-Removal.png",
      threeft: 59.99,
      fourft: 59.99,
      fourftSix: 59.99,
      fiveft: 59.99,
      sixft: 59.99,
      inStock: true,
    },
    {
      text: "Bed &amp; Mattress Removal",
      url: "https://cdn.shopify.com/s/files/1/0518/2157/6345/t/42/assets/Bed-Mattress%20Removal.png",
      threeft: 79.99,
      fourft: 79.99,
      fourftSix: 79.99,
      fiveft: 79.99,
      sixft: 79.99,
      inStock: true,
    },
  ],
  delivery: [
    {
      text: "Deliver As Soon As Possible",
      url: "https://cdn.shopify.com/s/files/1/0518/2157/6345/t/42/assets/Deliver-As-Soon-As-Possible.png",
      threeft: 0.0,
      fourft: 0.0,
      fourftSix: 0.0,
      fiveft: 0.0,
      sixft: 0.0,
      inStock: true,
    },
    {
      text: "Delay My Delivery Until After",
      url: "https://cdn.shopify.com/s/files/1/0518/2157/6345/t/42/assets/Delay-My-Delivery-Until-After.png",
      threeft: 0.0,
      fourft: 0.0,
      fourftSix: 0.0,
      fiveft: 0.0,
      sixft: 0.0,
      inStock: true,
    },
  ],
  matressPockets: [
    {
      text: "1000 Pockets",
      url: "https://cdn.shopify.com/s/files/1/0518/2157/6345/t/42/assets/Same-image-Pockets.png",
      threeft: 0.0,
      fourft: 0.0,
      fourftSix: 0.0,
      fiveft: 0.0,
      sixft: 0.0,
      inStock: true,
    },
    {
      text: "2000 Pockets",
      url: "https://cdn.shopify.com/s/files/1/0518/2157/6345/t/42/assets/Same-image-Pockets.png",
      threeft: 49.99,
      fourft: 54.99,
      fourftSix: 59.99,
      fiveft: 69.99,
      sixft: 69.99,
      inStock: true,
    },
    {
      text: "3000 Pockets",
      url: "https://cdn.shopify.com/s/files/1/0518/2157/6345/t/42/assets/Same-image-Pockets.png",
      threeft: 79.99,
      fourft: 84.99,
      fourftSix: 89.99,
      fiveft: 99.99,
      sixft: 129.99,
      inStock: true,
    },
  ],
};
